import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getSubSectionsList = async () => {
  return await axiosInstance.get("sub-sections/getlist", { headers });
};

export const getSubSectionsBySectionId = async (sectionId) => {
  return await axiosInstance.get(
    `sub-sections/getlist/by-section/${sectionId}`,
    { headers }
  );
};

export const getSubSectionById = async (id) => {
  const response = await axiosInstance.get(`sub-sections/get/${id}`, {
    headers,
  });
  return response.data.result;
};

export const addSubSection = async (payload) => {
  return await axiosInstance.post("sub-sections/add", payload, { headers });
};

export const updateSubSection = async (payload) => {
  return await axiosInstance.put("sub-sections/update", payload, { headers });
};

export const deleteSubSection = async (id) => {
  return await axiosInstance.delete(`sub-sections/delete/${id}`, { headers });
};
